var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allInOneContent"},[_c('div',{staticClass:"topBox"},[_c('div',{staticClass:"topTitle"},[_vm._v("4mm拼接屏")]),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.AllInOne1),expression:"AllInOne1"}],staticClass:"topImg",attrs:{"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0cf8316","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hardware/sensor.vue
// module id = null
// module chunks = 